'use client';

import { useIsDesktop } from '@/_hooks/useBreakpoint';
import { Box, Container, SimpleGrid, Text } from '@chakra-ui/react';
import Image from 'next/image';
import React, { useMemo } from 'react';
import Header from '@/app/[locale]/(home)/_components/Header';
import UniversalHeader from '@/_components/Header';
import SeoPageTitle from '@/_components/SeoPageTitle';
import { useTranslations } from 'next-intl';
import Breadcrumbs from '@/_components/Breadcrumbs';
const certificatePaths = [
  '/certificates/y1.webp',
  '/certificates/y2.webp',
  '/certificates/ya1.webp',
  '/certificates/ya2.webp',
  '/certificates/ymb1.webp',
  '/certificates/ymb2.webp',
  '/certificates/ymc1.webp',
  '/certificates/ymc2.webp',
  '/certificates/ymf1.webp',
  '/certificates/ymf2.webp',
  '/certificates/ymh1.webp',
  '/certificates/ymh2.webp',
  '/certificates/yms1.webp',
  '/certificates/yms2.webp',
  '/certificates/a1.webp',
  '/certificates/a2.webp',
  '/certificates/a3.webp',
  '/certificates/a4.webp',
  '/certificates/a5.webp',
  '/certificates/a6.webp',
  '/certificates/a7.webp',
  '/certificates/a8.webp',
  '/certificates/a9.webp',
  '/certificates/a10.webp',
  '/certificates/a11.webp',
  '/certificates/a12.webp',
  '/certificates/a13.webp',
  '/certificates/a14.webp',
  '/certificates/a15.webp',
  '/certificates/a16.webp',
  '/certificates/a17.webp',
  '/certificates/a18.webp',
  '/certificates/a19.webp',
  '/certificates/a20.webp',
  '/certificates/m1.webp',
  '/certificates/m2.webp',
  '/certificates/r1.webp',
  '/certificates/r2.webp',
  '/certificates/sp1.webp',
  '/certificates/sp2.webp',
  '/certificates/t1.webp',
  '/certificates/t2.webp',
  '/certificates/tosh1.webp',
  '/certificates/tosh2.webp',
];

function Certificate() {
  const t = useTranslations();
  const isDesktop = useIsDesktop();
  const breadCrumbs = useMemo(
    () => [
      {
        title: t('home'),
        link: '/',
      },
      {
        title: t('certificate'),
      },
    ],
    [t]
  );

  return (
    <Box bg='background' minH='100vh'>
      <Box display={{ base: 'none', lg: 'block' }}>
        <Header />
      </Box>
      <Box display={{ base: 'block', lg: 'none' }}>
        <UniversalHeader backLink='/profile' title={t('certificate')} />
        <SeoPageTitle>{t('certificate')}</SeoPageTitle>
      </Box>
      <Container maxW='1264px'>
        {isDesktop && <>
          <Breadcrumbs data={breadCrumbs} />
          <Text
            as='h1'
            mb={6}
            fontWeight={700}
            fontSize={{ base: '2xl', md: '3xl' }}
          >
            {t('certificate')}
          </Text>
        </>}
        <SimpleGrid pb={10} columns={{ base: 1, sm: 2, lg: 3 }} gap={6} mt={3}>
          {certificatePaths.map((path, index) => (
            <Box key={path} borderWidth='1px' overflow='hidden' bg='white'>
              <Image
                src={path}
                alt={`certificate-${index + 1}`}
                width={500}
                height={500}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}

export default Certificate;
